import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {
  title = 'WorldERP.com Terms & Condition';

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {property: 'og:title', content: 'WorldERP.com Terms & Condition'},
      {property: 'og:type', content: 'terms-conditions'},
      {property: 'og:url', content: '/terms-conditions'},
      {property: 'og:image', content: ''}
    ]);
  }

}
